import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from '../../index';

const ProfileProgress = ({
  value,
  color,
  message,
  isValueVisible,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `profile-progress ${className}`,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "profile-progress__row"
  }, /*#__PURE__*/React.createElement(Progress, {
    value: value,
    color: color
  }), isValueVisible && /*#__PURE__*/React.createElement("div", {
    className: "profile-progress__value"
  }, `${value}%`)), message && /*#__PURE__*/React.createElement("div", {
    className: "profile-progress__message"
  }, message));
};

ProfileProgress.defaultProps = {
  isValueVisible: true
};
ProfileProgress.propTypes = {
  value: PropTypes.number.isRequired,
  color: PropTypes.string,
  message: PropTypes.string,
  isValueVisible: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object
};
export default ProfileProgress;